import { useEffect, useState } from "react";
import { Box, Chip } from "@material-ui/core";
import _ from "lodash";
import { useOktaAuth } from "@okta/okta-react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { getHelp, sortFilterHelpContent } from "../actions";
import { differenceInMinutes } from "date-fns";

import List from "../components/Common/List";

const HelpList = () => {
    let history = useHistory();
    const { oktaAuth, authState } = useOktaAuth();
    const token = oktaAuth.getAccessToken();
    const dispatch = useDispatch();
    const listitems = useSelector((state) => state.help.usablelist);
    const currentAdmin = useSelector((state) => state.user.usable);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const pagetitle = "Help";
    const localstoragekey = false;
    // name from columnTemplates
    const defaultView = [
        { field: "name", name: "Name", friendlyname: "Name" },
        { field: "active", name: "Status", friendlyname: "Status" },
    ];
    const defaultColumns = [
        // all available columns
        { field: "name", name: "Name", friendlyname: "Name" },
        { field: "active", name: "Status", friendlyname: "Status" },
    ];
    const [headerRow, setHeaderRow] = useState(
        <div className='table-header' style={{ fontSize: "1.2rem" }}>
            {pagetitle}
        </div>
    );
    const [filter, setfilter] = useState({});
    const resetList = () => {
        if (!_.isEmpty(filter)) {
            dispatch(sortFilterHelpContent({ filters: filter }));
        } else {
            dispatch(getHelp(token));
        }
    };
    const filterSortList = (filterObj) => {
        dispatch(sortFilterHelpContent(filterObj));
    };
    const parselistitems = (items) => {
        return items;
    };
    useEffect(() => {
        console.log(selectedRow);
        // customize per list
        if (selectedRow && selectedRow.active === 1) {
            history.push(`/help/${selectedRow.slug}`);
        }
    }, [selectedRow]);
    useEffect(() => {
        // let _localoktasynctime = localStorage.getItem("oktausersynctime");
        // _localoktasynctime = JSON.parse(_localoktasynctime);
        // let _offsetsynctime = differenceInMinutes(new Date(), new Date(_localoktasynctime.lastran));
        if (selectedColumns && selectedColumns.length >= 1) {
            // <Box p={1} textAlign='center'>
            //     <Chip label={`Last Updated ${_offsetsynctime} minute(s) ago`} color='primary' />
            // </Box>;
            setHeaderRow(
                <Box flexGrow={1}>
                    <span style={{ fontSize: "1.2rem" }}>{pagetitle}</span>
                </Box>
            );
        }
    }, [selectedColumns]);
    useEffect(() => {
        console.log(currentAdmin);
        if (!_.isEmpty(currentAdmin)) {
            setfilter({
                active: {
                    value: "1",
                    matchMode: "equals",
                },
            });
        }
    }, [currentAdmin]);

    return (
        <>
            <h1>Help</h1>
            <div>Coming Soon!</div>
        </>
        // <List
        //     pagetitle={pagetitle}
        //     localstoragekey={localstoragekey}
        //     listitems={listitems}
        //     selectedRow={selectedRow}
        //     setSelectedRow={setSelectedRow}
        //     selectedColumns={selectedColumns}
        //     setSelectedColumns={setSelectedColumns}
        //     defaultColumns={defaultColumns}
        //     defaultView={defaultView}
        //     listfilter={filter}
        //     headerRow={headerRow}
        //     resetList={resetList}
        //     filterSortList={filterSortList}
        //     parselistitems={parselistitems}
        // />
    );
};

export default HelpList;
